define("shared/utils/hex-to-rgb", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  // Taken from http://gist.github.com/danieliser/b4b24c9f772066bcf0a6

  const convertHexToRGBA = function (hexCode) {
    let opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const isHex = c => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(c);
    if (!hexCode || !isHex(hexCode)) return;
    let _opacity = opacity;
    let hex = hexCode.replace('#', '');
    if (hex.length === 3) {
      hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    /* Backward compatibility for whole number based opacity values. */
    if (opacity > 1 && opacity <= 100) {
      _opacity = opacity / 100;
    }
    return `rgba(${r},${g},${b},${_opacity})`;
  };
  var _default = _exports.default = convertHexToRGBA;
});